import { render, staticRenderFns } from "./CreateNegotiation.vue?vue&type=template&id=04711582"
import script from "./CreateNegotiation.vue?vue&type=script&lang=js"
export * from "./CreateNegotiation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports